import './Mcq.css'
import React, { useState, useEffect } from 'react';
import { Radio, Button, Card, notification, Input, Checkbox, Progress, Space } from 'antd';
import { useNavigate, useParams } from 'react-router';
import { useStateValue } from '../../../../Reducer/reducer';
import QuizIcon from '@mui/icons-material/Quiz';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import axios from 'axios';
import { AssesmentUrl, BaseUrl } from '../../../Constants/Constants';
import Swal from 'sweetalert2';
import { actionTypes } from '../../../../Reducer/StateProvider';
import { message } from 'antd';





const Mcq = ( ) => {

    const navigate = useNavigate();

    const [
        { UserID, Questions },
        dispatch
    ] = useStateValue();

    // console.log(Questions,"questions")

    const [questions, setQuestions] = useState(Questions)



    const [api, contextHolder] = notification.useNotification();
    const [mcq_id , setmcq_id]= useState("")


    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [selectedOption, setSelectedOption] = useState('');
    const [timer, setTimer] = useState(1200); // 10 minutes in seconds
    const [BookmarkStatus, setBookmarkStatus] = useState(false)
    const history = useNavigate();
    const [Selected, setSelected] = useState('')
    const [UserResponses, setUserResponses] = useState([]);
    const [SelectedQuestionId, setSelectedQuestionId] = useState('')

    const [selectedAnswers, setSelectedAnswers] = useState({});
    

    const [viewedStatus, setViewedStatus] = useState(Array(questions.length).fill(false));
const [status, setStatus] = useState(new Array(questions.length).fill('unanswered'));
const [questionColors, setQuestionColors] = useState(new Array(questions.length).fill('transparent'));
const [initialized, setInitialized] = useState(false);

    const { id } = useParams();
    const { assessmentId } = useParams();

    const cleanedString = assessmentId.replace(/\s+/g, ' ');
    let modUrl = cleanedString.toLowerCase().split(' ');
    let url = modUrl.join('-');
    let structuredUrl = url.split('/').join('-');

    const questionChart = questions.map((_, index) => index + 1);
const rowsOfNumbers = [];
for (let i = 0; i < questionChart.length; i += 5) {
    rowsOfNumbers.push(questionChart.slice(i, i + 5));
}
    // console.log(timer, 'timerDetails')


    useEffect(() => {
        let body = {
            assessment_id: assessmentId
        }

        axios
            .post(`${BaseUrl}assesment/Assesment_details`,body, { withCredentials: true })
            .then((res) => {

                let duration = JSON.parse(res.data.data.Assesment_Duration);

                setTimer(duration*60)
                // setData(JSON.parse(res.data.data.Assesment_Duration))
                console.log(typeof JSON.parse(res.data.data.Assesment_Duration) ,"len")
            })
            .catch((err) => {

            })
            .finally((res) => {
            })
    }, [])

    const formatQuestion = (question) => {
        if (!question) return ''; 
    
        let formattedQuestion = question.replace(/\\n\s*([a-zA-Z])\./g, '<br/>$1.');
    
        formattedQuestion = formattedQuestion.replace(/(?:^|\s)([a-z])\./g, (match, p1) => {
            return match.replace(p1, p1.toUpperCase());
        });
        formattedQuestion = formattedQuestion.replace(/\\n(?!\s*[a-zA-Z]\.)/g, '<br/>');
        formattedQuestion = formattedQuestion.replace(/\s*<br\/>\s*/g, '<br/>');
        return formattedQuestion;
    };

    useEffect(() => {
        const countdown = setInterval(() => {
            setTimer((prevTimer) => {
                if (prevTimer === 0) {
                    clearInterval(countdown);
                    // Redirect to the result page or handle quiz completion
                    history(`/courses/${id}/assessment/${structuredUrl}/mcq/result`);
                }
                return prevTimer - 1;
            });
        }, 1000);

        return () => clearInterval(countdown);
    }, [history]);


    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
    };

    const handleOptionSelect = (e, questionId) => {
        const selectedOption = e.target.value;
        setSelectedOption(selectedOption);
    
        const updatedResponses = [...UserResponses];
        const existingResponseIndex = updatedResponses.findIndex(
            (response) => response?.question_id === questionId
        );
    
        if (existingResponseIndex !== -1) {
            updatedResponses[existingResponseIndex] = { question_id: questionId, answer: selectedOption };
        } else {
            updatedResponses.push({ question_id: questionId, answer: selectedOption });
        }
    
        setUserResponses(updatedResponses);
    
        const updatedStatus = [...status];
        updatedStatus[currentQuestion] = 'answered';
        setStatus(updatedStatus);
    
        const updatedColors = [...questionColors];
        updatedColors[currentQuestion] = 'green'; 
        setQuestionColors(updatedColors);
    };
    
    console.log( "channnn", UserResponses);
    // console.log(selectedOption, "selected")

    const openNotificationWithIconWarning = (type) => {
        api['warning']({
            message: "Warning!!!",
            description:
                type,  
        });
    };

    const openAlert = (type) => {
        Swal.fire({
            title: 'Alert!!!',
            text: type,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'OK',
            allowOutsideClick: false 
        }).then((result) => {
            if (result.isConfirmed) {
                
               navigate(`/courses/${id}`)
            }
        });
    };


    useEffect(() => {
        if (UserResponses.length > 0 && questions[currentQuestion]) {
          const currentQuestionId = questions[currentQuestion]?.question_id;
          const existingResponse = UserResponses.find(
            (response) => response?.question_id === currentQuestionId
          );
    
          if (existingResponse) {
            setSelectedOption(existingResponse.answer);
          } else {
            setSelectedOption(null);
          }
        }
      }, [currentQuestion, questions,UserResponses]);

      const handleNextQuestion = () => {
        handleLeavingQuestion(); // This will check if the current question is unanswered and mark it accordingly
    
        if (currentQuestion < questions.length - 1) {
            setCurrentQuestion((prev) => prev + 1);
            setSelectedOption(UserResponses[currentQuestion + 1]?.answer || null);
        }
    };

    const handlePreviousQuestion = () => {
        handleLeavingQuestion();
        if (currentQuestion > 0) {
            setCurrentQuestion((prev) => prev - 1);
            setSelectedOption(UserResponses[currentQuestion - 1]?.answer || null);
        }
    };

    
    const handleAnswerQuestion = () => {
        const updatedStatus = [...status];
        updatedStatus[currentQuestion] = 'answered';
        setStatus(updatedStatus);
    
       
        const updatedColors = [...questionColors];
        updatedColors[currentQuestion] = 'green'; 
        setQuestionColors(updatedColors);
    };
    
    
const allQuestionsAnswered = (questions, responses) => {
  return questions.every(q => {
    const res = responses.find(r => r?.question_id === q?.question_id);
    if (!res || res.answer == null) return false;
    if (Array.isArray(res.answer)) return res.answer.length > 0;
    if (typeof res.answer === 'string') return res.answer.trim() !== '';
    return false;
  });
};

//     const handleFinish = () => {
//             setUserResponses((prevResponses) => [...prevResponses, { "question_id": SelectedQuestionId, "answer": selectedOption }]);



//             const answeredQuestions = UserResponses.filter((resp) => {
//   if (!resp || resp.answer == null) return false;

//   if (Array.isArray(resp.answer)) {
//     return resp.answer.length > 0;
//   }

//   if (typeof resp.answer === "string") {
//     return resp.answer.trim() !== "";
//   }

//   return false;
// }).length;

// if (answeredQuestions === questions.length) {


//                 setAssessmentCompleted(true);
//                 let body = {
//                     course_id: id,
//                     user_id: UserID,
//                     user_answer: UserResponses,
//                     assessment_id : assessmentId
//                 }
//                 axios
//                     .post(`${AssesmentUrl}mcq_validation`, body)
//                     .then((res) => {
//                         console.log(res, "response")
                    
//                         closeFullscreen();
//                         history(`/courses/${id}/assessment/${structuredUrl}/mcq/result`);
//                     })
//                     .catch((err) => {
//                         console.log(err)
//                     })
            
//         }
//         else {
//             openNotificationWithIconWarning('Select atleast one option');
//         }

//     }

const handleFinish = () => {
  const updatedResponses = [...UserResponses];
  const currentQuestionId = questions[currentQuestion]?.question_id;

  const existingIndex = updatedResponses.findIndex(
    (resp) => resp?.question_id === currentQuestionId
  );

  if (existingIndex !== -1) {
    updatedResponses[existingIndex].answer = selectedOption;
  } else {
    updatedResponses.push({
      question_id: currentQuestionId,
      answer: selectedOption,
    });
  }

  const allAnswered = allQuestionsAnswered(questions, updatedResponses);

  if (allAnswered) {
    setAssessmentCompleted(true);

    const body = {
      course_id: id,
      user_id: UserID,
      user_answer: updatedResponses,
      assessment_id: assessmentId,
    };

    axios
      .post(`${AssesmentUrl}mcq_validation`, body)
      .then((res) => {
        console.log(res, "response");
        closeFullscreen();
        // history(`/courses/${id}/assessment/${structuredUrl}/mcq/result`);
        const data= res?.data
          const isEligible = data?.eligibility;
          const attempt = data?.assessment_attempt_count || 1;

     dispatch({
                type: actionTypes.SET_Eligibility,
                eligibility: res.data.eligibility
              })
              localStorage.setItem("course_eligibility", res?.data?.eligibility);

if (isEligible==='Pass') {
  message.success("You have Successfully completed the course", 6);

  // 🚀 Call your new backend API to send completion email
 axios.post(`${BaseUrl}courses/completed`, {
    userId: UserID,
    courseId: id,
    eligibility: "Pass"
  }, {
    withCredentials: true, 

  }).then((res) => {
    console.log("Completion API response:", res.data);
  }).catch((err) => {
    console.error("Error calling completion API", err);
  });
} else {
  if (attempt <= 1) {
    message.warning(
      "Your recent attempt didn't meet the criteria for successful completion. To successfully complete the course, please take a re-attempt.",
      8
    );
  } else {
    message.error(
      "Your second and final attempt did not meet the minimum requirements for course completion.",
      6
    );
  }

  // 🚀 Call API but mark fail
  axios.post(`${BaseUrl}courses/completed`, {
    userId: UserID,
    courseId: id,
    eligibility: "fail"
  }, {
    withCredentials: true, 

  }).then((res) => {
    console.log("Completion API response:", res.data);
  }).catch((err) => {
    console.error("Error calling completion API for fail case", err);
  });
}



         history(`/courses/${id}/assessment/${structuredUrl}/mcq/result`);
      
      })



      //then-catch

      .catch((err) => {
        console.log(err);
      });
  } else {
    openNotificationWithIconWarning("Select at least one option");
  }
};
    const HandleSlected = (e) => {
        let selectedNum = questions.find((i) => i.id == parseInt(e))
        // questions.push()
        console.log(e, "clicked", selectedNum)
    }
    const handleQuestionClick = (questionIndex, selectedOption) => {
       
        const isCorrect = questions[questionIndex].correctAnswer === selectedOption;
        const updatedStatus = [...status];
        updatedStatus[questionIndex] = isCorrect ? 'correct' : 'incorrect';
        setStatus(updatedStatus);
    };
    const HandleSelected = (questionId) => {
       
        setCurrentQuestion(questionId - 1);  
        
       
        const updatedColors = [...questionColors];
        updatedColors[questionId - 1] = selectedOption ? 'answered' : 'unanswered';
        setQuestionColors(updatedColors);
    };
    const handleSelectedQuestion = (questionId) => {
        handleLeavingQuestion();
        const questionIndex = questionId - 1;
        setCurrentQuestion(questionIndex);
        setSelectedOption(UserResponses[questionIndex]?.answer || null);
    };
    const HandleBookmark = (e) => {
        const isBookmarked = e === currentQuestion - 1;
        setBookmarkStatus(isBookmarked)
    }
    // useEffect(() => {
    //     const handleVisibilityChange = () => {
    //       if (document.visibilityState === 'hidden') {
    //         console.log("switched")
    //         // User switched to a different tab or minimized the window
    //         openAlert('Switching Tabs leads to end assesment');

    //         // navigate(`/courses/${id}`)



    //       }
    //     };

    //     document.addEventListener('visibilitychange', handleVisibilityChange);

    //     return () => {
    //       // Cleanup the event listener when the component unmounts
    //       document.removeEventListener('visibilitychange', handleVisibilityChange);
    //     };
    //   }, []);
    useEffect(() => {
        const handleBeforeUnload = (event) => {
            // You can perform actions here before the page is unloaded/reloaded
            console.log('Page is about to be reloaded');

            // Optionally, you can show a confirmation message
            const confirmationMessage = 'Are you sure you want to leave?';
            event.returnValue = confirmationMessage;
            return confirmationMessage;
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            // Cleanup the event listener when the component unmounts
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);




    const [isFullScreen, setIsFullScreen] = useState(false);
    const [assessmentCompleted, setAssessmentCompleted] = useState(false);

    const openFullscreen = () => {
        const doc = document.documentElement;
        // if (doc.requestFullscreen) {
        //   doc.requestFullscreen();
        // } 
        // else 
        if (doc.mozRequestFullScreen) { // Firefox
            doc.mozRequestFullScreen();
        } else if (doc.webkitRequestFullscreen) { // Chrome, Safari and Opera
            doc.webkitRequestFullscreen();
        } else if (doc.msRequestFullscreen) { // IE/Edge
            doc.msRequestFullscreen();
        }
        setIsFullScreen(true);
    };

    const closeFullscreen = () => {
        // if (document.exitFullscreen) {
        //   document.exitFullscreen();
        // } else 
        if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
        setIsFullScreen(false);
    };

    //   useEffect(() => {

    //     openFullscreen();

    //   },[]);

    //   useEffect(() => {
    //     const handleBeforeUnload = (event) => {
    //       if (isFullScreen && !assessmentCompleted) {
    //         const message = "Are you sure you want to exit? Your assessment is not complete.";
    //         event.returnValue = message; // Standard for most browsers
    //         return message; // For some older browsers
    //       }
    //     };

    //     window.addEventListener('beforeunload', handleBeforeUnload);

    //     return () => {
    //       window.removeEventListener('beforeunload', handleBeforeUnload);
    //     };
    //   }, [isFullScreen, assessmentCompleted]);
    // console.log(questions.length,"ques",questions)

const handleSelectedAns = (value) => {
   if (!questions[currentQuestion]) return;
  setSelectedOption(value);

  const updatedResponses = [...UserResponses];
  updatedResponses[currentQuestion] = {
    question_id: questions[currentQuestion]?.question_id,
    answer: value,
  };
  setUserResponses(updatedResponses);

  // ✅ Mark question as answered
  const updatedStatus = [...status];
  updatedStatus[currentQuestion] = 'answered';
  setStatus(updatedStatus);

  // ✅ Set color to green
  const updatedColors = [...questionColors];
  updatedColors[currentQuestion] = 'green';
  setQuestionColors(updatedColors);
};


useEffect(() => {
  if (UserResponses.length > 0) {
    const currentQuestionId = questions[currentQuestion]?.question_id;
    const existingResponse = UserResponses.find(
      (response) => response?.question_id === currentQuestionId
    );

    if (existingResponse) {
      setSelectedOption(existingResponse.answer);
    } else {
      setSelectedOption(null);
    }
  }
}, [currentQuestion, questions]);






    useEffect(() => {
        if (viewedStatus[currentQuestion] && status[currentQuestion] === 'unanswered') {
            const updatedStatus = [...status];
            updatedStatus[currentQuestion] = 'viewed-unanswered';
            setStatus(updatedStatus);
        }
    }, [currentQuestion]);

    
 
    // useEffect(() => {
    //     if (UserResponses.length > 0) {
    //         const currentQuestionId = questions[currentQuestion]?.question_id;
    //         const existingResponse = UserResponses.find(
    //             (response) => response.question_id === currentQuestionId
    //         );
    
    //         if (existingResponse) {
    //             setSelectedOption(existingResponse.answer);
    //         } else {
    //             setSelectedOption(null);
    //         }
    //     }
    // }, [currentQuestion, questions, UserResponses]);


  
    

 
    useEffect(() => {
        if (viewedStatus[currentQuestion] && status[currentQuestion] === 'unanswered') {
            const updatedStatus = [...status];
            updatedStatus[currentQuestion] = 'viewed-unanswered';
            setStatus(updatedStatus);
        }
    }, [currentQuestion]);

    const markQuestionAsViewed = (questionIndex) => {
        if (status[questionIndex] === 'unanswered' && !viewedStatus[questionIndex]) {
            const updatedViewedStatus = [...viewedStatus];
            updatedViewedStatus[questionIndex] = true;
            setViewedStatus(updatedViewedStatus);
        }
    };
    const handleLeavingQuestion = () => {
        const currentQ = currentQuestion;
    
        // Only update if the question is unanswered and viewed
        if (status[currentQ] === 'unanswered' && selectedOption === null) {
            const updatedStatus = [...status];
            updatedStatus[currentQ] = 'viewed-unanswered';
            setStatus(updatedStatus);
    
            const updatedColors = [...questionColors];
            updatedColors[currentQ] = 'red'; // Set color to red
            setQuestionColors(updatedColors);
        }
    };

   




    // useEffect(() => {
    //     // Initialize statuses and colors
    //     const initialStatuses = new Array(questions.length).fill('unanswered');
    //     const initialColors = new Array(questions.length).fill('transparent');
    
    //     // If there's at least one question, set the first question's status and color
    //     if (questions.length > 0) {
    //         if (selectedOption === null) {
    //             // Assume the first question is viewed and unanswered
    //             initialStatuses[0] = 'viewed-unanswered';
    //             initialColors[0] = 'red';
    //         }
    //     }
    
    //     setStatus(initialStatuses);
    //     setQuestionColors(initialColors);
    // }, [questions, selectedOption]);

    // useEffect(() => {
    //     if (currentQuestion >= 0 && currentQuestion < questions.length) {
    //         // Mark the current question as viewed if it is unanswered
    //         const updatedStatus = [...status];
    //         const updatedColors = [...questionColors];
    
    //         if (status[currentQuestion] === 'unanswered' && !viewedStatus[currentQuestion]) {
    //             updatedStatus[currentQuestion] = 'viewed-unanswered';
    //             updatedColors[currentQuestion] = 'red'; // Change color to red
    //             setViewedStatus(prevViewedStatus => {
    //                 const newViewedStatus = [...prevViewedStatus];
    //                 newViewedStatus[currentQuestion] = true;
    //                 return newViewedStatus;
    //             });
    //         }
    
    //         setStatus(updatedStatus);
    //         setQuestionColors(updatedColors);
    //     }
    // }, [currentQuestion, status, viewedStatus, questionColors]);

    // useEffect(() => {
    //     // Mark the first question as viewed and unanswered on initial load
    //     if (questions.length > 0 && currentQuestion === 0) {
    //         setStatus(prevStatus => {
    //             const newStatus = [...prevStatus];
    //             newStatus[0] = 'viewed-unanswered';
    //             return newStatus;
    //         });
    //         setQuestionColors(prevColors => {
    //             const newColors = [...prevColors];
    //             newColors[0] = 'red';
    //             return newColors;
    //         });
    //     }
    // }, [questions, currentQuestion]);
    useEffect(() => {
        // Check if transitioning from the first question
        if (currentQuestion > 0 && currentQuestion < questions.length) {
            const previousQuestion = 0;
            const updatedStatus = [...status];
            const updatedColors = [...questionColors];
    
            // Mark the previous question as viewed and unanswered if it was not answered
            if (status[previousQuestion] === 'unanswered' && selectedOption === null) {
                updatedStatus[previousQuestion] = 'viewed-unanswered';
                updatedColors[previousQuestion] = 'red'; // Set color to red
            }
    
            // Update the status and color for the current question
            // Initialize the current question status as 'unanswered'
           
            // Set the updated status and colors
            setStatus(updatedStatus);
            setQuestionColors(updatedColors);
    
            // Mark the current question as viewed
            setViewedStatus(prevViewedStatus => {
                const newViewedStatus = [...prevViewedStatus];
                newViewedStatus[currentQuestion] = true;
                return newViewedStatus;
            });
        }
    }, [currentQuestion, status, selectedOption]);
    
    



console.log('Current Question:', currentQuestion);
console.log('Status:', status);
console.log('Question Colors:', questionColors);

useEffect(() => {
  const style = document.createElement("style");
  style.innerHTML = `
    .questionParagraphinmcq img {
      max-width: 100%;
      height: 400px;
      display: block;
      margin: 10px 0;
    }
  `;
  document.head.appendChild(style);
  return () => {
    document.head.removeChild(style);
  };
}, []);
    
return (
    <div className='mcqMainDiv'>
        {contextHolder}
        {currentQuestion < questions.length ? (
            <div className='mcqContainer'>
                {/* Left Side - Question Card */}
                <div className='mcqQuestionSection'>
                    <Card className='mcqQuestionCard'>
                        {/* Question Header */}
                        <div className='mcqQuestionHeader'>
                            <div className='mcqQuestionHeaderLeft'>
                                <div className='mcqQuestionNumberBadge'>
                                    <QuizIcon className='mcqQuestionIcon' />
                                    <span className='mcqQuestionNumber'>Question {currentQuestion + 1} of {questions.length}</span>
                                </div>
                            </div>
                            <div className='mcqTimerBadge'>
                                <AccessTimeIcon className='mcqTimerIcon' />
                                <span className='mcqTimerText'>{formatTime(timer)}</span>
                            </div>
                        </div>

                        {/* Progress Bar */}
                        <div className='mcqProgressBar'>
                            <Progress 
                                percent={((currentQuestion + 1) / questions.length) * 100} 
                                showInfo={false}
                                strokeColor={{
                                    '0%': '#667eea',
                                    '100%': '#764ba2',
                                }}
                                strokeWidth={8}
                            />
                        </div>

                        {/* Question Content */}
                        <div className='mcqQuestionContent'>
                            <div 
                                className='mcqQuestionText' 
                                dangerouslySetInnerHTML={{
                                    __html: formatQuestion(questions[currentQuestion]?.question)
                                }}
                            />

                            {/* Answer Options */}
                            <div className='mcqOptionsContainer'>
                                {questions[currentQuestion]?.options?.every(opt => opt === null) ? (
                                    <Input
                                        placeholder="Enter your answer"
                                        value={selectedOption || ""}
                                        onChange={(e) => handleSelectedAns(e.target.value)}
                                        className='mcqTextInput'
                                        size="large"
                                    />
                                ) : questions[currentQuestion]?.question_type === 'ma_mcq' ? (
                                    <Checkbox.Group
                                        value={selectedOption || []}
                                        onChange={(checkedValues) => handleSelectedAns(checkedValues)}
                                        className='mcqCheckboxGroup'
                                    >
                                        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                                            {questions[currentQuestion]?.options?.map((option, index) =>
                                                option !== null ? (
                                                    <div key={index} className='mcqOptionItem checkboxOption'>
                                                        <Checkbox value={option} className='mcqCheckbox'>
                                                            <span className='mcqOptionText'>{option}</span>
                                                        </Checkbox>
                                                    </div>
                                                ) : null
                                            )}
                                        </Space>
                                    </Checkbox.Group>
                                ) : (
                                    <Radio.Group
                                        onChange={(e) => handleOptionSelect(e, questions[currentQuestion]?.question_id)}
                                        value={selectedOption}
                                        className='mcqRadioGroup'
                                    >
                                        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                                            {questions[currentQuestion]?.options?.map((option, index) =>
                                                option !== null ? (
                                                    <div key={index} className='mcqOptionItem radioOption' onClick={() => handleSelectedAns(option)}>
                                                        <Radio value={option} className='mcqRadio'>
                                                            <span className='mcqOptionText'>{option}</span>
                                                        </Radio>
                                                    </div>
                                                ) : null
                                            )}
                                        </Space>
                                    </Radio.Group>
                                )}
                            </div>
                        </div>

                        {/* Navigation Buttons */}
                        <div className='mcqNavigationButtons'>
                            {currentQuestion > 0 && (
                                <Button 
                                    type="default" 
                                    onClick={handlePreviousQuestion}
                                    className='mcqNavButton prevButton'
                                    icon={<ArrowBackIcon />}
                                    size="large"
                                >
                                    Previous
                                </Button>
                            )}
                            {currentQuestion !== questions.length - 1 ? (
                                <Button 
                                    type="primary" 
                                    onClick={handleNextQuestion}
                                    className='mcqNavButton nextButton'
                                    icon={<ArrowForwardIcon />}
                                    size="large"
                                >
                                    Next Question
                                </Button>
                            ) : (
                                allQuestionsAnswered(questions, UserResponses) && (
                                    <Button 
                                        type="primary" 
                                        onClick={handleFinish}
                                        className='mcqNavButton finishButton'
                                        icon={<CheckCircleIcon />}
                                        size="large"
                                    >
                                        Submit Assessment
                                    </Button>
                                )
                            )}
                        </div>
                    </Card>
                </div>

                {/* Right Side - Question Chart & Timer */}
                <div className='mcqSidebarSection'>
                    <Card className='mcqSidebarCard'>
                        <div className='mcqSidebarHeader'>
                            <QuizIcon className='mcqSidebarIcon' />
                            <h3 className='mcqSidebarTitle'>Question Navigator</h3>
                        </div>
                        
                        <div className='mcqQuestionChart'>
                            {[...Array(Math.ceil(questions.length / 5)).keys()].map((rowIndex) => (
                                <div key={rowIndex} className='mcqQuestionChartRow'>
                                    {questions.slice(rowIndex * 5, rowIndex * 5 + 5).map((_, index) => {
                                        const questionId = rowIndex * 5 + index + 1;
                                        const questionIndex = questionId - 1;
                                        const isAnswered = status[questionIndex] === 'answered';
                                        const isViewedUnanswered = status[questionIndex] === 'viewed-unanswered';
                                        const isSelected = currentQuestion === questionIndex;

                                        return (
                                            <div
                                                key={questionId}
                                                onClick={() => handleSelectedQuestion(questionId)}
                                                className={`mcqQuestionNumberItem ${
                                                    isSelected ? 'selected' : ''
                                                } ${
                                                    isAnswered ? 'answered' : isViewedUnanswered ? 'viewedUnanswered' : 'unanswered'
                                                }`}
                                            >
                                                {questionId}
                                            </div>
                                        );
                                    })}
                                </div>
                            ))}
                        </div>

                        <div className='mcqLegend'>
                            <div className='mcqLegendItem'>
                                <div className='mcqLegendColor answered'></div>
                                <span>Answered</span>
                            </div>
                            <div className='mcqLegendItem'>
                                <div className='mcqLegendColor viewedUnanswered'></div>
                                <span>Not Answered</span>
                            </div>
                            <div className='mcqLegendItem'>
                                <div className='mcqLegendColor unanswered'></div>
                                <span>Not Visited</span>
                            </div>
                        </div>

                        <div className='mcqTimerCard'>
                            <div className='mcqTimerContent'>
                                <AccessTimeIcon className='mcqTimerLargeIcon' />
                                <div className='mcqTimerInfo'>
                                    <span className='mcqTimerLabel'>Time Remaining</span>
                                    <span className='mcqTimerValue'>{formatTime(timer)}</span>
                                </div>
                            </div>
                        </div>
                    </Card>
                </div>
            </div>
        ) : (
            <div className='mcqNoQuestions'>
                <h3>No Questions Available</h3>
            </div>
        )}
    </div>
);
};

export default Mcq;
